import { render, staticRenderFns } from "./MessagesUnreadBagde.vue?vue&type=template&id=7c756a33&scoped=true"
import script from "./MessagesUnreadBagde.vue?vue&type=script&lang=js"
export * from "./MessagesUnreadBagde.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c756a33",
  null
  
)

export default component.exports